// Libs
import React, { PureComponent } from 'react'
import _find from 'lodash/find'
import _get from 'lodash/get'
import _map from 'lodash/map'

// Components
import Select from 'react-select'
import SamplingPointDetail from './SamplingPointDetail'

// Constants
import {
  SOIL_TEST_FILTER_OPTIONS as filterOptions,
} from 'fc-model-soil-test-results/src/constants'

// Filters
import { optionsFilter } from 'fc-model-soil-test-results'

// Icons
import FilterIcon from 'fc-icons/src/Filter'

import { message as messageCommonStyle, attentionMessage as attentionCommonStyle } from 'hfty-styles/src/common'
import { grey, primary, white } from 'hfty-styles/src/colors'

const INDENT = '15px'

const styles = {
  wrapper: {
    margin: `${INDENT} 0`,
  },
  filterIcon: {
    display: 'block',
    padding: '11px',
    backgroundColor: grey(),
  },
  holder: {
    border: '1px solid rgb(220, 218, 218)',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    textAlign: 'center',
  },
  thead: {
    background: primary(),
    color: white(),
  },
  th: {
    padding: '9px',
    fontWeight: 300,
  },
  tbody: {
    fontSize: '.875rem',
    backgroundColor: white(),
  },
}

type Props = {
  samplingPoints: Object,
  filter: ?string,
  selectedPoint: ?number,
  onSelect: Function,
  onHover: Function,
  jobStatus: string,
  undoEditing: Function,
  isEditing: boolean,
}

class SamplingPointsTable extends PureComponent {
  props: Props

  componentWillUnmount () {
    this.props.undoEditing()
  }

  render () {
    const { samplingPoints, onHover, filter, selectedPoint, jobStatus } = this.props
    const options = optionsFilter(samplingPoints)
    const filterOption = filter ? _find(filterOptions, (option) => option.value === filter) : null

    return (
      <div style={styles.wrapper}>
        <p style={messageCommonStyle}>
          Mouseover a sample below to see it on the map
        </p>
        {this.props.isEditing &&
        <p style={attentionCommonStyle}>
          {/* eslint-disable max-len */}
          Please ensure that you have synced this job from the app before you make changes. Any unsynchronized changes from the app will overwrite edits to Bag ID that you make on web. Changes must be made and the job must be closed before ordering tests.
          {/* eslint-enable max-len */}
        </p>}
        <div style={styles.holder}>
          <div className='select-with-icon-label'>
            <FilterIcon
              size={14}
              color={white()}
              style={styles.filterIcon}
            />
            <Select
              placeholder={'Select an attribute...'}
              value={filterOption}
              options={options}
              disabled={!samplingPoints}
              onChange={this.props.onSelect}
            />
          </div>
          <table style={styles.table}>
            <thead style={styles.thead}>
              <tr>
                <th style={styles.th}>#</th>
                <th style={styles.th}>Bag ID</th>
                <th style={styles.th}>{_get(filterOption, 'label', undefined) || 'Coordinates'}</th>
              </tr>
            </thead>
            <tbody style={styles.tbody}>
              {_map(samplingPoints, (point, key) => {
                return (
                  <SamplingPointDetail
                    key={key}
                    jobStatus={jobStatus}
                    point={point}
                    pointNumber={key}
                    onHover={onHover}
                    filter={filter}
                    hoveredPoint={null}
                    selectedPoint={selectedPoint}
                  />)
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default SamplingPointsTable
